"use client";

import { useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./ConfirmarAsistenciaExtra.css";

export default function ConfirmarAsistenciaExtra() {
  const [form, setForm] = useState({
    nombre: "",
    asistencia: "sí",
    mensaje: ""
  });

  const [respuesta, setRespuesta] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.nombre.trim()) {
      setRespuesta({
        ok: false,
        msg: "Por favor ingresá tu nombre y apellido."
      });
      return;
    }

    try {
      const asistenciaFinal = form.asistencia.toLowerCase() === "no" ? "No" : "Sí";
      const mensajeFinal = form.mensaje.trim() !== "" ? form.mensaje : "Ninguno";

      await addDoc(collection(db, "asistencias"), {
        nombre: form.nombre.trim(),
        asistencia: asistenciaFinal,
        mensaje: mensajeFinal,
        fecha: serverTimestamp(),
      });

      setRespuesta({
        ok: true,
        msg: `¡Gracias, ${form.nombre.trim()}! Tu respuesta ha sido registrada con éxito.`,
        check: true
      });

      setForm({
        nombre: "",
        asistencia: "sí",
        mensaje: ""
      });
    } catch (err) {
      console.error(err);
      setRespuesta({
        ok: false,
        msg: "Error al enviar. Intentá nuevamente."
      });
    }
  };

  return (
    <section className="confirmar-asistencia-seccion">
      <div className="card-form">
        <img 
          src="/lista.png" 
          alt="Icono lista" 
          className="icono-lista"
        />
        <h2>Confirmá tu asistencia</h2>
        <p className="subtitulo-fecha">Confirmar antes del <strong>25 de Octubre</strong></p>

        {!respuesta?.ok ? (
          <form onSubmit={handleSubmit} className="formulario-asistencia">
            <input
              type="text"
              name="nombre"
              placeholder="Nombre y apellido"
              value={form.nombre}
              onChange={handleChange}
              required
            />

            <label className="label-inline">
              Voy a:
              <select
                name="asistencia"
                value={form.asistencia}
                onChange={handleChange}
              >
                <option value="sí">Asistir</option>
                <option value="no">No asistir</option>
              </select>
            </label>

            <textarea
              name="mensaje"
              placeholder="¿Algún mensaje para los novios? (opcional)"
              value={form.mensaje}
              onChange={handleChange}
            />

            <button type="submit">
              Enviar
            </button>
          </form>
        ) : (
          <div className="mensaje-confirmacion">
            {respuesta.check && (
              <img 
                src="/check.png"   // tu imagen PNG en /public/check.png
                alt="Confirmación exitosa"
                className="check-icon"
              />
            )}
            <p className="mensaje-exito">{respuesta.msg}</p>
          </div>
        )}
      </div>
    </section>
  );
}
